/** EmptyState.tsx — no-rows placeholder. */
import React from 'react';

export default function EmptyState({
	title = 'No data',
	hint,
}: {
	title?: string;
	hint?: string;
}) {
	return (
		<div className="empty-state">
			<div style={{ fontWeight: 600, marginBottom: 4 }}>{title}</div>
			{hint && <div style={{ fontSize: 13 }}>{hint}</div>}
		</div>
	);
}
